export default "__VITE_ASSET__wu0waFWW__"